import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  img100: {
    height: '100px',
    width: '100px',
  }
}))